export function isNotUndefined<T>(value: T): value is Exclude<T, undefined> {
    return value !== undefined;
}

export function isNotNullOrUndefined<T>(value: T): value is Exclude<T, undefined | null> {
    return value !== undefined && value != null;
}

export function intersperse<T>(arr: T[], elem: T): T[] {
    return arr.reduce((result, next) => result.concat(next, elem), [] as T[]);
}

export const nameof = <T>(name: keyof T) => name;

export function isHtml(str: string): boolean {
    const resultStr = (str || '')
        // replace html tag with content
        .replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1>/gi, '')
        // remove remaining self closing tags
        .replace(/(<([^>]+)>)/gi, '')
        // remove extra space at start and end
        .trim();

    return !resultStr;
}

export function getInnerTextFromHtml(text: string): string {
    const doc = document.createElement('div');
    doc.innerHTML = text;
    return doc.innerText;
}
